module.exports = "https://portperrypedals.ca/_res/img/our_cancer_dark.769ceca.png";